import { apiClient } from "@/services/api/client";
import type { NotificationApiResponse } from "@/features/notifications/modal/notification.types";
import type { ApiResponse } from "@/services/api/api.types";
import { API_ENDPOINTS } from "@/services/api/endpoints";
import { logger } from "@/lib";

export const notificationService = {
  async getAndyNotifications(
    page = 1,
    pageSize = 20,
    type: string
  ): Promise<NotificationApiResponse> {
    const { data } = await apiClient.get<NotificationApiResponse>(
      API_ENDPOINTS.NOTIFICATION.LIST(page, pageSize, type)
    );
    return data;
  },

  async markAllNotificationsRead(type: string): Promise<NotificationApiResponse> {
    logger.info("Marking all notifications as read");
    const { data } = await apiClient.post<NotificationApiResponse>(
      API_ENDPOINTS.NOTIFICATION.SEEN_ALL(type)
    );
    return data;
  },

  async registerDevice(
    platform: "ios" | "android" | "web",
    deviceToken: string
  ): Promise<ApiResponse<unknown>> {
    logger.info("Registering device token for push notifications", { platform, deviceToken });
    const { data } = await apiClient.post<ApiResponse<unknown>>(API_ENDPOINTS.NOTIFICATION.DEVICE, {
      platform,
      device_token: deviceToken,
    });
    return data;
  },
};
